export default __webpack_public_path__ + "static/media/RegistrationFees.74fe5ade.svg";